export default "__VITE_ASSET__Bl82DMaO__"